import React from "react";
import styled from "styled-components";
import SideBarNav from "./SideBarNav";
import SideBarDisplay from "./SideBarDisplay";

const StyledWrapper = styled.div`
  width: 366px;
  height: 100%;
  background-color: #f4f1de;
  border-right: 1px solid #f2cc8f;
  display: flex;
`;

export default function SideBar() {
  return (
    <StyledWrapper>
      <SideBarNav />
      <SideBarDisplay />
    </StyledWrapper>
  );
}
